<template>
    <ui-modal
        :size="sizeModal"
        name="units-data"
        title="Dados da Unidade"
        color-title="title-primary"
    >
        <div v-if="loader.general" class="loader-units-modal">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
        </div>

        <div
            v-else
            class="body-content scroll-color"
            :class="{
                'flex-column-active': !showSalesTable,
            }"
        >
            <div class="content-left-right">
                <section
                    v-if="data"
                    class="body-content-left scroll-color"
                    :class="{'disabled-scroll': disabledScroll}"
                >
                    <div
                        v-if="customFields.length > 0"
                        class="arrow-infos"
                        @click="arrowInfos = !arrowInfos"
                    >
                        <i v-if="!arrowInfos" class="fas fa-chevron-left" />
                        <i v-if="arrowInfos" class="fas fa-chevron-right" />
                    </div>

                    <div class="body-content-left-situation" :style="{ 'background': data.bg_color }">
                        <div class="number">{{ data.number }}</div>
                        {{ situations[data.situation]?.name || '-' }}
                    </div>

                    <div class="body-content-left-content-expires">
                        <span class="content">
                            {{ unitInfo }}
                            <span v-if="showCost">
                                - <span v-if="data.cost != false">{{ data.cost | currencyBRL }}</span>
                            </span>
                        </span>

                        <div v-if="expirationDate" class="expires">
                            Expira em: {{ expirationDate }}
                        </div>

                        <div class="detail-enterprise">
                            <span v-if="data?.garage" class="detail">
                                {{ data.garage }} vagas
                            </span>

                            <span v-if="data?.infos?.typology" class="detail">{{ data.infos.typology }}</span>
                        </div>

                        <div v-if="data?.observations" class="detail-observation">
                            <span class="observation">{{ data.observations }}</span>
                        </div>
                    </div>

                    <template v-if="unitActiveReservation">
                        <ui-card-units-customer :data="unitActiveReservation.deal" />

                        <div class="body-content-left-responsible">
                            <ui-image
                                :src="responsible.photo"
                                :arrow-popover="false"
                                design="circle"
                                h="40"
                                w="40"
                            />
                            <div class="responsible">
                                {{ responsible.first_name }}
                                <span>Responsável</span>
                            </div>
                        </div>
                    </template>

                    <div
                        v-if="!showSalesTable && data?.permission_action"
                        class="select-footer"
                    >
                        O que você deseja fazer?

                        <div class="select" @click="clickSelectHandler">
                            <ui-select-v2
                                v-model="action"
                                :data="actionOptionsComputed"
                                :search="false"
                                @input="actionHandler"
                            />
                        </div>
                    </div>
                </section>

                <section v-if="arrowInfos" class="body-content-information scroll-color-primary">
                    <span class="others-information">Outras Informações</span>

                    <div
                        v-for="(field, i) in customFields"
                        :key="i"
                        class="content-information"
                        :class="{ 'content-detail': field.value?.length < 20 && field.label?.length < 20}"
                    >
                        <div class="title-information">
                            <span>{{ field.label }}:&nbsp;</span>
                        </div>

                        <div class="information">
                            <span class="information-value">{{ field.value }}</span>
                        </div>
                    </div>
                </section>

                <div class="hy" />

                <section v-if="showSalesTable" class="body-content-right scroll-color">
                    <div class="body-content-right-select">
                        <div class="body-content-right-select-table-sales">
                            <ui-select-v2
                                v-model="form.data.sales_table_id"
                                :data="salesTableOptions"
                                :loading="loader.selectSalesTable"
                                :search="false"
                                label="Tabela de Vendas"
                                align="left"
                                item-label="name"
                                return-value="id"
                                @input="salesTableHandler"
                            />
                        </div>

                        <div class="body-content-right-select-payment-flow">
                            <ui-select-v2
                                v-model="form.data.sales_table_flow_id"
                                :data="salesTableFlowOptions"
                                :loading="loader.selectSalesTableFlow"
                                :search="false"
                                label="Fluxo de Pagamentos"
                                align="right"
                                item-label="name"
                                return-value="id"
                                @input="salesTableFlowHandler"
                            />
                        </div>
                    </div>

                    <div
                        v-if="showSalesTable && salesTableFlow && salesTableFlowOptions.length > 0"
                        class="body-content-right-table-annual-fixed-amount scroll-color"
                    >
                        <div class="table-content">
                            <span>{{ salesTableFlow.name }}</span>
                        </div>

                        <div class="scroll-color table-tr">
                            <table border="1">
                                <tr>
                                    <th>Parcela</th>
                                    <th>Quantidade</th>
                                    <th class="value">Valor</th>
                                </tr>
                                <tr v-for="(item, index) in series" :key="index">
                                    <td class="td">{{returnParcelTypes(item) }}</td>
                                    <td class="td">{{ item.quantity }}x</td>
                                    <td class="td">
                                        <span>
                                            {{ item.first_value | currencyBRL }}
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div v-if="salesTable?.observations" class="detail-observation">
                            <span class="observation">{{ salesTable.observations }}</span>
                        </div>
                    </div>

                    <div
                        v-if="!loader.general && ['available', 'reserved'].includes(data?.situation) && data?.permission_action"
                        class="select-footer"
                    >
                        O que você deseja fazer?

                        <div class="select" @click="clickSelectHandler">
                            <ui-select-v2
                                v-model="action"
                                :data="actionOptionsComputed"
                                :search="false"
                                @input="actionHandler"
                            />
                        </div>
                    </div>
                </section>
            </div>

            <div v-if="data && !loader.general" class="container-footer">
                <div class="update">
                    <i class="fal fa-calendar-alt" />
                    Atualização: <span>{{ updatedAt }}</span>
                </div>
            </div>
        </div>
    </ui-modal>
</template>

<script>
	import { uiImage, uiLoadIndicator } from '@/components/ui'
    import { uiSelectV2 } from '@/components/ui/form'
    import { uiModal } from '@/components/ui/modal'
    import uiCardUnitsCustomer from '../card-units-customer'

    import { availability } from '@/services/axios'
    import { storage } from '@/services/storage'

    import { currencyBRL } from '@/filters'
    import helpers from '@/mixins/helpers'

    import { mapActions, mapGetters } from 'vuex'

    const moment = require('moment')
	require('moment/locale/pt-br')

	export default {
		name: 'ui-modal-units-data',

		components: {
			uiModal,
			uiCardUnitsCustomer,
			uiImage,
			uiSelectV2,
            uiLoadIndicator
		},

        filters: { currencyBRL },

        mixins: [helpers],

        data() {
            return {
                action: null,
                actionOptions: [
                    {
                        label: 'Visualizar Histórico de Reservas',
                        value: 'history',
                        show: true
                    },
                    {
                        label: 'Solicitar uma Reserva',
                        value: 'reserve',
                        show: true
                    },
                    {
                        label: 'Simular Proposta',
                        value: 'simulation',
                        show: true
                    },
                    {
                        label: 'Preencher Proposta',
                        value: 'proposal',
                        show: true
                    },
                ],
                configurations: {
                    allowed_menu: [],
                    proposal_settings: null
                },
                data: null,
                loader: {
                    general: false,
                    selectSalesTable: false,
                    selectSalesTableFlow: false
                },
                salesTableOptions: [],
                salesTableFlowOptions: [],
                form: {
                    data: {
                        sales_table_id: null,
                        sales_table_flow_id: null,
                    }
                },
                arrowInfos: false,
                parcelTypeLabels: JSON.parse(storage.get('parcel_types')),
                // parcelTypeLabels: {
                //     act: 'Ato',
                //     signal: 'Entrada',
                //     unique: 'Única',
                //     fixed_value: 'Valor Fixo',
                //     monthly: 'Mensal',
                //     bimonthly: 'Bimestral',
                //     quarterly: 'Trimestral',
                //     four_monthly: 'Quadrimestral',
                //     semester: 'Semestral',
                //     yearly: 'Anual',
                //     intermediary: 'Intermediária',
                //     keys: 'Chaves',
                //     fgts: 'FGTS',
                //     financing: 'Financiamento',
                //     allowance: 'Subsídio',
                //     bonus: 'Bonificação',
                //     assets_rights: 'Bem e Direito'
                // },
                disabledScroll: false
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/getUser',
                product: 'product/getProduct',
                salesTable: 'simulation/getSalesTable',
                salesTableFlow: 'simulation/getSalesTableFlow',
                situations: 'product/getSituations',
                series: 'simulation/getSeries'
            }),
            /**
             * Computed property que verifica se ao menos uma tabela de vendas possui um fluxo
             * de pagamento
             */
            showSalesTable() {
                return !!this.salesTableOptions.find(salesTable => {
                    return salesTable.sales_table_flow?.length &&
                        ['available', 'reserved'].includes(this.data.situation)
                })
            },
            sizeModal() {
                if(this.showSalesTable && !this.arrowInfos) return 'md'
                if(!this.showSalesTable && this.arrowInfos) return 'md'
                if(this.showSalesTable && this.arrowInfos) return 'lg'
                return 'sm'
            },
            /**
             * Computed property que retorna os dados da unidade formatados de acordo com o tipo
             * de disponibilidade
             */
            unitInfo() {
                if (!this.data) return '-'

                let info = ''
                const showProperty = !this.product?.infos?.multiProperty?.hideNumberAndBlock

                if (this.data.floor && this.data.floor != '') {
                    if (this.data.floor == 0) info = `Térreo - `
                    else info = `${this.data.floor}º andar - `

                    if (this.data.infos && this.data.infos.typology) {
                        info += `${this.data.infos.typology} - `
                    }

                    if (showProperty) info += 'Torre '
                    if (this.data.block) info += `${this.data.block} - `
                    if (this.data.area) info += `${this.data.area} m²`

                } else {
                    if (showProperty) info += 'Quadra '
                    if (this.data.block) info += `${this.data.block} - `
                    if (this.data.infos && this.data.infos.typology) info += `${this.data.infos.typology} - `
                    if (this.data.area) info += `${this.data.area} m²`
                }

                return info
            },

            /**
             * Computed property que retorna a reserva ativa para a unidade
             */
            unitActiveReservation() {
                return Object.values(this.data?.reserves || []).sort((a, b) => {
                    return moment(a.created_at).unix() - moment(b.created_at).unix()
                })
                .find(() => true)
            },

            /**
             * Computed property que retorna o responsável pelo negócio/cliente
             */
            responsible() {
                let owner = null
                if (this.unitActiveReservation?.deal?.owners) {
                    if (this.unitActiveReservation.deal.owners.broker) {
                        owner = { ...this.unitActiveReservation.deal.owners.broker.user }

                    } else if (this.unitActiveReservation.deal.owners.manager) {
                        owner = { ...this.unitActiveReservation.deal.owners.manager.user }

                    } else {
                        owner = { ...this.unitActiveReservation.deal.owners.owner }
                    }
                }

                return owner
            },
            /**
             * Computed property que retorna a data de expiração da reserva ativa
             */
            expirationDate() {
                let date = this.unitActiveReservation?.created_at
                    ? moment(this.unitActiveReservation.created_at)
                    : null

                if (date && this.unitActiveReservation?.expire_time) {
                    const time = this.unitActiveReservation.expire_time.split(':')
                    date = date.add(time[0], 'h').add(time[1], 'm').add(time[2], 's')
                }

                return date ? date.format("DD/MM/YYYY [às] HH:mm") : ''
            },
            /**
             * Computed property que retorna a data de atualização da unidade
             */
            updatedAt() {
                return this.data.updated_at
                    ? moment(this.data.updated_at).format("dddd, DD [de] MMMM [de] YYYY")
                    : '-'
            },
            /**
             * Computed property que define as ações a serem mostradas no select
             */
            actionOptionsComputed() {
                return Object.values(this.actionOptions).filter(option => option.show)
            },
            /**
             * Computed property que define se deve ser mostrado o valor da unidade, de acordo
             * com a regra de visualização definida na etapa 2
             */
            showCost() {
                let show = true
                if (this.product?.infos?.showValue === 'hidden') {
                    show = false

                } else if (this.product?.infos?.showValue === 'available') {
                    show = this.data?.situation === 'available'
                }

                return show
            },
            /**
             * Computed property que retorna os dados dos campos personalizados formatados
             */
            customFields() {
                return Object.values(this.data?.fields?.field_group || [])
                    .filter(group => group.field?.value?.value)
                    .map(group => {
                        return {
                            label: group.field.name,
                            value: group.field.value.value
                        }
                    })
            }
        },

		mounted() {
			this.$root.$on('modal-open-units-data', payload => {
                if (!this.product) {
                    this.$toastr.e('Nenhum produto foi configurado para a unidade!')
                    return
                }

                this.loadUnitData(payload).then(() => {
                    this.action = null
                    this.configurations.allowed_menu = storage.get('allowed_menu').split(',')
                    this.configurations.allowed_apps = storage.get('allowed_apps').split(',')
                    this.configurations.proposal_settings = JSON.parse(storage.get('proposal_settings'))
                    // Verifica se o sistema de reservas está ativo para o produto
                    const reservesActive = this.product?.infos?.reserve?.status === 'active'
                    // Verifica se a fila de reservas está ativa para o produto
                    const queueReservesActive = this.product?.infos?.reserve?.queueReserve?.status === 'active'
                    // Verifica se o sistema de reservas está ativo para o sistema
                    let allowedMenuReserves = this.configurations?.allowed_menu.includes('reservas')

                    this.actionOptions = this.actionOptions.map(action => {
                        switch (action.value) {
                            case 'history':
                                action.show = this.user?.user_group === 'admin' &&
                                    allowedMenuReserves &&
                                    reservesActive
                                break

                            case 'reserve':
                                action.show = reservesActive &&
                                    allowedMenuReserves &&
                                    (this.data?.situation === 'available' ||
                                    (this.data?.situation === 'reserved' && queueReservesActive))  &&
                                    this.data?.situation !== 'sale' &&
                                     (queueReservesActive || this.situationReservedValidate())
                                break

                            case 'simulation':
                                action.show = this.configurations?.allowed_apps.includes('simulator') &&
                                                this.data?.situation !== 'sale'&& this.situationReservedValidate()
                                action.label = this.configurations?.proposal_settings?.simulation?.menu_name ||
                                    'Simular Proposta'
                                break

                            case 'proposal':
                                action.show = this.configurations.allowed_menu.includes('propostas') &&
                                                this.data?.situation !== 'sale' && this.situationReservedValidate()
                                action.label = this.configurations.proposal_settings.proposal.menu_name ||
                                    'Preencher Proposta'
                                break
                        }

                        return action
                    })

                    if (this.data?.availability?.sales_table) {
                        this.salesTableOptions = Object.values(this.data.availability.sales_table)

                    } else {
                        this.salesTableOptions = []
                        this.salesTableFlowOptions = []
                    }
                    this.setSimulationProduct({
                        product: {
                            ...this.product,
                            availability: { ...this.data?.availability }
                        }
                    })
                    this.setSimulationUnity({ unity: this.data })
                    this.loadInitialFlow()
                })
            })

			this.$root.$on('modal-close-units-data', payload => {
                payload === undefined ? this.arrowInfos = false : null
            })
		},

		beforeDestroy() {
			this.$root.$off('modal-close-units-data')
		},

        methods: {
            ...mapActions('simulation', [
                'setSalesTable',
                'setDiscount',
                'setSalesTableFlow',
                'generateSimulationSeries',
                'setSimulationProduct',
                'setSimulationUnity',
            ]),
            /**
             * Carrega os dados completos da unidade de acordo com o tipo de disponibilidade do produto
             */
            loadUnitData(payload) {
                let params =  { visualization: payload.visualization, header: true }
                // Verifica se é uma integração ERP para enviar o ID da disponibilidade
                if (payload.availability_id) params.availability_id = payload.availability_id

                this.loader.general = true
                return availability.getV2('units', payload.id, params)
                    .then(response => {
                        this.data = { ...response.data.data }
                        this.data.bg_color = this.product.situations[this.data.situation]?.color || '#400000'
                    })
                    .catch(error => {
                        if (error?.data?.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.loader.general = false
                    })
            },
            /**
             * Carrega o primeiro fluxo da primeira tabela de vendas
             */
            loadInitialFlow() {
                this.loader.selectSalesTableFlow = true
                let flow = null
                /**
                 * Verifica se a disponibilidade do produto possui tabelas de vendas e
                 * carrega o primeiro fluxo da primeira tabela
                 */
                if (this.salesTableOptions.length) {
                    /** Pega a primeira tabela de vendas */
                    const salesTable = this.salesTableOptions[0]
                    this.form.data.sales_table_id = salesTable.id
                    this.form.data.salesTable = { ...salesTable }
                    this.setSalesTable(salesTable)
                    this.salesTableFlowOptions = Object.values(salesTable.sales_table_flow)

                    /** Pega o primeiro fluxo e gera as séries/parcelas */
                    flow = this.salesTableFlowOptions.find(option => parseInt(option.position) === 1)
                    if (flow && flow.id) this.form.data.sales_table_flow_id = flow.id
                }

                this.setSalesTableFlow(flow || null)
                this.generateSimulationSeries()
                this.loader.selectSalesTableFlow = false
            },
            /**
             * Event handler que trata o select quando é aberto pra o scroll não influenciar no height do select
             */
            clickSelectHandler() {
                this.disabledScroll = !this.disabledScroll
            },
            /**
             * Event handler que trata o evento de quando uma ação é selecionada no select
             */
            actionHandler(event) {
                let params = null
                switch (event.value) {
                    case 'history':
                        /**
                         * Caso o ID inclua a string '.' identifica-se como uma unidade de integração ERP.
                         * Assim, separa-se a string e pega a segunda parte que contém o ID da unidade
                         * para acessar o histórico
                         */
                        var id = typeof this.data.id === 'string' && this.data.id.includes('.')
                            ? this.data.id.split('.')[1]
                            : this.data.id
                        this.$mx_oldPanelLinkButton(`vendas/historico/${id}`)
                        break

                    case 'reserve':
                        params = {
                            id: this.product.id,
                            product: this.product.id,
                            product_type: this.product.availability.type,
                            unit: this.data.id,
                            block: this.data.block,
                            floor: this.data.floor
                        }
                        this.$root.$emit('modal-open-global--request-reserve', null, true, false, params, false)
                        this.$root.$emit('modal-close-units-data')
                        this.arrowInfos = false
                        break

                    case 'simulation':
                        params = {
                            step2: {
                                product: {
                                    ...this.product,
                                    availability: { ...this.data.availability }
                                },
                                product_id: this.product.id,
                                unity: { ...this.data },
                                unity_id: this.data.id,
                                sales_table_id: this.form.data.sales_table_id,
                                sales_table_flow_id: this.form.data.sales_table_flow_id
                            }
                        }
                        storage.setLegacy(`guide_simulationUnity_${this.user.id}`, JSON.stringify(params))
                        this.$router.push({ name: 'sales.simulation' })
                        break

                    case 'proposal':
                        params = {
                            action: 'createProposal',
                            product_id: this.product.id,
                            unity_id: this.data.id,
                        }
                        this.$root.$emit('modal-open-create-deal-modal', params, true)
                        this.$root.$emit('modal-close-units-data')
                        break
                }
            },
            /**
             * Trata o evento de quando uma tabela de vendas é selecionada, de modo a carregar
             * os fluxos
             */
            salesTableHandler(value) {
                if(!parseInt(value)) this.form.data.sales_table_id = null
                this.salesTableFlowOptions = []
                this.form.data.sales_table_flow_id = null

                this.loader.selectSalesTableFlow = true
                if (parseInt(value)) {
                    setTimeout(() => {
                        const salesTable = Object.values(this.salesTableOptions)
                            .find(table => table.id === parseInt(value))
                        if (salesTable && salesTable.id) {
                            this.salesTableFlowOptions = salesTable.sales_table_flow &&
                                Object.values(salesTable.sales_table_flow).length
                                    ? Object.values(salesTable.sales_table_flow)
                                    : []
                            this.form.data.salesTable = salesTable
                            this.setSalesTable(salesTable)
                            this.setDiscount(salesTable)
                            if (this.salesTableFlowOptions.length) {
                                /** Pega o primeiro fluxo e gera as séries/parcelas */
                                let flow = this.salesTableFlowOptions.find(option => parseInt(option.position) === 1)
                                if (flow && flow.id) this.form.data.sales_table_flow_id = flow.id
                                this.setSalesTableFlow(flow || null)
                                this.generateSimulationSeries()
                            }

                        } else {
                            this.setSalesTableFlow(null)
                        }
                        this.loader.selectSalesTableFlow = false
                    }, 500)

                } else {
                    setTimeout(() => {
                        this.loader.selectSalesTableFlow = false
                    }, 500)
                }
            },
            /**
             * Trata o evento de quando um fluxo é selecionado, de modo a gerar as séries
             */
            salesTableFlowHandler(value) {
                if (parseInt(value)) {
                    if (this.form.data.salesTable && this.form.data.salesTable.id) {
                        const flow = Object.values(this.form.data.salesTable.sales_table_flow).find(flow => flow.id === parseInt(value))
                        this.setSalesTableFlow(flow)
                        this.generateSimulationSeries()

                    } else {
                        this.$toastr.e('A tabela de vendas selecionada não existe')
                    }

                } else {
                    setTimeout(() => {
                        this.$toastr.e('Selecione um fluxo válido')
                    }, 500)
                }
            },
            situationReservedValidate() {
                const isReserved = this.data?.situation === 'reserved' || this.data?.situation ===  'waiting';
                const hasReserves = Array.isArray(this.data?.reserves) && this.data.reserves.length > 0;
                const currentUserId = this.user?.id;
                const isAdmin = this.user?.user_group === 'admin';

                // Verifica se algum ID do solicitante no array de reservas é igual ao ID do usuário atual
                const isCurrentUserRequester = hasReserves &&
                    this.data.reserves.some(reserve => reserve?.requestered_user?.id === currentUserId);

                // Se estiver reservado e o usuário atual não for o solicitante e não for admin, retorna false
                return !(isReserved && (!isCurrentUserRequester && !isAdmin));
            },
            returnParcelTypes(item) {
                return this.parcelTypeLabels.find(parcel => parcel.value === item.type_installment)?.display_name
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
